const STEPS = [
  {
    icon: "ri-emotion-happy-line",
    title: "先看风向",
    desc: "我们不急着复述事件，而是先告诉你评论区现在是支持多还是质疑多，一秒判断这场瓜的基调。",
  },
  {
    icon: "ri-chat-quote-line",
    title: "再看神评",
    desc: "高赞评论往往比通稿更有信息量。我们把最锋利的几条挑出来，让你直接看到网友的核心观点。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "最后自己判断",
    desc: "我们只呈现，不定性。每条评论都保留原貌，结论留给你自己，毕竟吃瓜也需要独立判断。",
  },
];

export default function Method() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">
              HOW WE READ
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              我们怎么读一条评论区
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            同一场瓜，有人看热闹，有人看门道。瓜田观察提供三个固定的观察角度，让围观更有条理。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {STEPS.map((step, index) => (
            <div
              key={step.title}
              className="relative rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="absolute right-5 top-5 font-heading text-4xl font-black text-background-300">
                0{index + 1}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className={`${step.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}